import DataOriginName from "./DataOriginName";

export default DataOriginName;
export { DataOriginName };
